import request from '@/utils/request'

// 查询帮助问题列表
export function listHelp(query) {
  return request({
    url: '/system/help/list',
    method: 'get',
    params: query
  })
}

// 查询帮助问题分页
export function pageHelp(query) {
  return request({
    url: '/system/help/page',
    method: 'get',
    params: query
  })
}

// 查询帮助问题详细
export function getHelp(data) {
  return request({
    url: '/system/help/detail',
    method: 'get',
    params: data
  })
}

// 新增帮助问题
export function addHelp(data) {
  return request({
    url: '/system/help/add',
    method: 'post',
    data: data
  })
}

// 修改帮助问题
export function updateHelp(data) {
  return request({
    url: '/system/help/edit',
    method: 'post',
    data: data
  })
}

// 删除帮助问题
export function delHelp(data) {
  return request({
    url: '/system/help/delete',
    method: 'post',
    data: data
  })
}
